import MatterIndicators from 'components/matters/MatterIndicators';
import { RecordLink } from 'components/record-chip/RecordLink';
import { FC, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { MatterAssignmentMinDto } from 'types/assignments';

interface Props {
    assignment: MatterAssignmentMinDto;
}

const CorrespondenceAssignmentItem: FC<Props> = ({ assignment }) => {
    if (!assignment.matter) {
        return <div>{assignment.name}</div>;
    }

    return (
        <div>
            <FormattedMessage
                id="correspondence.assignment-of-matter"
                values={{
                    assignment: assignment.name,
                    matter: (
                        <Fragment key="matter">
                            <MatterIndicators isConfidential={assignment.matter.isConfidential} className="mr-1" />
                            <RecordLink
                                withOrigin
                                className="entity-link text-fg hover:text-link no-underline hover:underline"
                                to={`/matter/${assignment.matter.id}`}
                                label={assignment.matter.fullName}
                            />
                        </Fragment>
                    ),
                }}
            />
        </div>
    );
};

export default CorrespondenceAssignmentItem;
